import { FieldValues, Path, PathValue, UseFormSetValue } from 'react-hook-form';

import { FieldActionType } from './useFormRenderV2/constants';

export const useFieldAction = <TFieldValues extends FieldValues>({
  fieldName,
  setValue,
  fieldActionType,
}: {
  fieldName: Path<TFieldValues>;
  setValue: UseFormSetValue<TFieldValues>;
  fieldActionType?: FieldActionType;
}) => {
  const handleAssignToMyself = () => {
    setValue(fieldName, 'me' as PathValue<TFieldValues, Path<TFieldValues>>, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  if (fieldActionType === FieldActionType.ASSIGN_TO_MYSELF) {
    return handleAssignToMyself;
  }

  return undefined;
};
